import { api } from "@/lib/api"

/**
 * Quien puede entrar y con que alcance.
 *
 *   GET    /api/auth/roles
 *   GET    /api/auth/accesos
 *   DELETE /api/auth/accesos/{id}
 *   GET    /api/auth/invitaciones
 *   POST   /api/auth/invitaciones
 *   DELETE /api/auth/invitaciones/{id}
 *   POST   /api/auth/invitaciones/aceptar
 *
 * SIN MOCK. Estas llamadas deciden quien toca la contabilidad de una empresa:
 * un mock que responde «invitado» sin invitar a nadie, o que muestra accesos
 * que no existen, es lo unico que no se puede permitir aqui.
 */

export interface RolDisponible {
  codigo: string
  capacidades: string[]
  puede_firmar: boolean
  puede_dar_accesos: boolean
  /** `false` = el backend lo va a rechazar. No se ofrece. */
  concedible_por_ti: boolean
}

export function fetchRoles(): Promise<{
  roles: RolDisponible[]
  puedes_conceder: string[]
  nota: string
}> {
  return api.get("/auth/roles")
}

export interface Acceso {
  id: string
  app_user_id: string
  email: string
  nombre: string | null
  rol: string
  entity_id: string | null
  razon_social: string | null
  vigente_desde: string | null
  puede_firmar: boolean
  puede_dar_accesos: boolean
  activo: boolean
}

export function fetchAccesos(): Promise<{
  accesos: Acceso[]
  firmantes: number
  aviso: string | null
}> {
  return api.get("/auth/accesos")
}

export function quitarAcceso(id: string): Promise<{ email: string }> {
  return api.delete(`/auth/accesos/${id}`)
}

export interface Invitacion {
  id: string
  email: string
  rol: string
  estado: "pendiente" | "aceptada" | "revocada" | "vencida"
  creado_en: string
  expira_en: string
  aceptada_en: string | null
  entity_id: string | null
  razon_social: string | null
  invitado_por: string | null
}

export function fetchInvitaciones(): Promise<Invitacion[]> {
  return api.get("/auth/invitaciones")
}

export function invitar(payload: {
  email: string
  rol: string
  entity_id?: string | null
  mensaje?: string | null
  motivo: string
}): Promise<{
  id: string
  email: string
  rol: string
  expira_en: string
  /** Se devuelve UNA sola vez: despues solo se guarda su hash. */
  token: string
  ruta_para_aceptar: string
  correo_enviado: boolean
  aviso: string
}> {
  return api.post("/auth/invitaciones", payload)
}

export function revocarInvitacion(id: string): Promise<{ id: string }> {
  return api.delete(`/auth/invitaciones/${id}`)
}

export function aceptarInvitacion(token: string): Promise<{
  tenant_id: string
  rol: string
  aviso: string
}> {
  return api.post("/auth/invitaciones/aceptar", { token })
}
